import React from 'react'

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

var tracery = require('tracery-grammar');


const grammarEN = {
"CHOSENSUBJECT":["a beginning"],
"SATZ":["#CHOSENSUBJECT# #VERB# #OBJECT#."],
"OBJECT":["[CHOSENSUBJECT:#SUBJECT#] #CHOSENSUBJECT#"],
"ADJSUBJECT":["a #ADJSSTEM# #SUBJECTS_#"],
"SUBJECTS_":["hand", "tongue", "desparation", "malady", "darkness", "light", "community", "warmth", "survey", "collection", "wall", "coldness", "splendor", "power", "sentence", "meaning", "start", "doubt", "death", "success", "word", "heart", "conclusion", "hope", "desire", "fire", "face", "wish", "finger", "reward", "point", "closeness", "beginning"],
"SUBJECTS":["a #SUBJECTS_#"],
"SUBJECT":["#SUBJECTS#", "#ADJSUBJECT#", "#ADJSUBJECT#", "#ADJSUBJECT#"],
"VERB":["is"],
"ADJSSTEM":["simple", "fast", "slow", "soft", "hard", "dark", "light", "small", "huge", "cheap", "valuable", "lazy", "hot", "cold", "new", "dated", "smart", "dumb", ],
"origin":["#SATZ#"]
}

const grammarDE = {
"chosensubject":["ein anfang"],
"satz":["#chosensubject# #verb# #object#."],
"object":["[chosensubject:#subject#] #chosensubject#"],
"verb":["ist"],
"origin":["#satz#"],
"SUBJECTSS":["wort", "herz", "ende", "hoffen", "verlangen", "feuer", "gesicht", "begehren"],
"SUBJECTSM":["satz", "sinn", "beginn", "zweifel", "tod", "besitz", "erfolg", "anfang"],
"SUBJECTSW":["hand", "zunge", "hoffnung", "verzweiflung", "krankheit", "finsternis", "helle", "sucht", "gemeinschaft", "wärme", "untersuchung", "vereinnahmung", "wand", "kälte", "wärme", "pracht", "macht", "gewalt"],
"ADJSSTEM":["einfach", "schnell", "langsam", "weich", "hart", "finster", "hell", "klein", "gross", "billig", "teuer", "faul", "heiss", "kalt", "neu", "alt", "klug", "einfältig"],
"subjects":["eine #SUBJECTSW#", "ein #SUBJECTSM#", "ein #SUBJECTSS#"],
"subject":["#subjects#", "#ADJSUBJECT#"],
"ADJSUBJECT":["eine #ADJSSTEM#e #SUBJECTSW#", "ein #ADJSSTEM#er #SUBJECTSM#", "ein #ADJSSTEM#es #SUBJECTSS#"]
}

let strings = new LocalizedStrings({
    en:{
        title:"a beginning",
        ending:"beginning.",
        description:"a formal grammar generates a random constellation of chained definitions. the program begins at the symbol START and replaces it with SENTENCE. the symbol SENTENCE is then substituted with the rule’s content and so on.\nthe symbol | dennotes random choices the algorithm can make. capitalized symbols are substituted by the rule’s content whereas lowercase characters are copied into the results without any substitution. the rules of the formal grammar:\nSTART ➔ SENTENCE\nCHOSENSUBJECT ➔ a beginning\nVERB ➔ is\nSENTENCE ➔ CHOSENSUBJECT VERB OBJECT.\nOBJECT ➔ {CHOSENSUBJECT:SUBJECT} CHOSENSUBJECT\nSUBJECT ➔ SUBJECTS | ADJSUBJECT | ADJSUBJECT | ADJSUBJECT\nADJSUBJECT ➔ a ADJSSTEM SUBJECTS\nADJSSTEM ➔ simple | fast | slow | soft | hard | dark | light | small | huge | cheap | valuable | lazy | hot | cold | new | dated | smart | dumb\nSUBJECTS ➔ a SUBJECTS2\nSUBJECTS2 ➔ hand | tongue | desparation | malady | darkness | light | community | warmth | survey | collection | wall | coldness | splendor | power | sentence | meaning | start | doubt | death | success | word | heart | conclusion | hope | desire | fire | face | wish | finger | reward | point | closeness | beginning\n"
    },
    de: {
        title:"ein anfang",
        ending:"anfang.",
        description:"eine formale grammatik generiert eine zufällige anordnung an miteinander verketteten definitionen. das programm beginnt dabei immer beim symbol START und ersetzt dieses durch SATZ. das symbol SATZ wird wiederum durch die bestandteile der regel ersetzt. senkrechte striche stellen möglichkeiten des algorithmus dar, die zufällig ausgewählt werden. grossgeschriebene symbole werden weiter ersetzt, kleingeschriebene ohne ersetzung in den text eingefügt.\ndie regeln der formalen grammatik:\nSTART ➔ SATZ\nSUBJECTS ➔ eine SUBJECTSW | ein SUBJECTSM | ein SUBJECTSS\nOBJECT ➔ {CHOSENSUBJECT:SUBJECT} CHOSENSUBJECT\nSUBJECTSW ➔ hand | zunge | hoffnung | verzweiflung | krankheit | finsternis | helle | sucht | gemeinschaft | wärme | untersuchung | vereinnahmung | wand | kälte | wärme | pracht | macht | gewalt\nSATZ ➔ CHOSENSUBJECT ist OBJECT.\nCHOSENSUBJECT ➔ ein finsteres ende\nSUBJECTSM ➔ satz | sinn | beginn | zweifel | tod | besitz | erfolg | anfang\nSUBJECT ➔ SUBJECTS | ADJSUBJECT\nADJSSTEM ➔ einfach | schnell | langsam | weich | hart | finster | hell | klein | gross | billig | teuer | faul | heiss | kalt | neu | alt | klug | einfältig\nADJSUBJECT ➔ eine ADJSSTEM+e SUBJECTSW | ein ADJSSTEM+er SUBJECTSM | ein ADJSSTEM+es SUBJECTSS\nSUBJECTSS ➔ wort | herz | ende | hoffen | verlangen | feuer | gesicht | begehren"
    }
});

class Beginning extends React.Component {
    constructor(props) {
        super(props)

        this.state = {verses:[]}
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    generate() {
        if (this.state.generatedLanguage !== this.context.language) {
            var grammarLang = this.context.language === "en" ? grammarEN : grammarDE;
            var ending = strings.ending;
            var grammar = tracery.createGrammar(grammarLang);

            var verses = []

            while(true) {
                var verse = grammar.expand("#origin#").finishedText

                verses.push(verse)
                if (verse.endsWith(ending)) {
                    break;
                }
            }

            this.setState({verses: verses, generatedLanguage: this.context.language})
        }
    }

    render() {
        strings.setLanguage(this.context.language)
        this.generate()

        return <div className="poemDisplay">
            {this.state.verses.map(function(verse, index){
                return <p key={index}>{verse}</p>;
              })}
        </div>
    }
}
Beginning.contextType = LanguageContext

export default Beginning
